// extracted by mini-css-extract-plugin
export default {"head":"TableHead_head__lExz6","row":"TableHead_row__VnWeK","item":"TableHead_item__og0dQ"};